module.exports = __webpack_public_path__ + "img/curriculo20212.ab22624c.png";